import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const ContractHeader: TableHeaderType[] = [
    {
      label: LABELS.ContractID,
      key: 'requesterUniqueId',
      id: 'requesterUniqueId',
      sortable: false,
      alignment:'center'
    },
    {
      id: 'provisionedDateTime',
      label: 'ProvisioningDate',
      alignment: 'center',
      sortable: true,
      key: 'provisionedDateTime',
    },

    {
      id: 'resourceStatus',
      label: 'Status',
      alignment: '',
      sortable: true,
      key: 'resourceStatus',
      width: '300px',
    },
    {
        id: 'decomissionedDate',
        label: 'DecommisioningDate',
        alignment: '',
        sortable: true,
        key: 'decomissionedDate',
      },
    {
      id: 'outputTemplateName',
      label: 'OutputTemplate',
      alignment: 'center',
      sortable: false,
      key: 'outputTemplateName',
    },
       {
      id: 'actions',
      label:'',
      alignment: '',
      sortable: false,
      key: '',
    },
  ];